// Collection media preferences belong to their collection-view, not to every card.
document.addEventListener('product-card:media-view', (event) => {
  const collectionView = event.target;
  if (!(collectionView instanceof Element) || !collectionView.matches('collection-view')) return;
  const mode = collectionView.dataset.productMediaMode;
  if (mode !== 'primary' && mode !== 'secondary') return;

  collectionView.querySelectorAll('.product-card .product-card__media.has-slider').forEach((container) => {
    delete container.dataset.slideIndex;
    container.querySelector(':scope > .slider-wrapper')?.style.removeProperty('transform');
    container.querySelectorAll('.segment').forEach((segment, index) => {
      segment.classList.toggle('active', index === (mode === 'secondary' ? 1 : 0));
    });
  });
});

// Delegation also handles cards inserted by filters, recommendations and dialogs.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const control = event.target.closest('.slider-arrow, .segment');
  const container = control?.closest('.product-card .product-card__media.has-slider');
  if (!container) return;
  const wrapper = container.querySelector(':scope > .slider-wrapper');
  const slides = wrapper?.querySelectorAll(':scope > .product-card__image');
  if (!slides || slides.length < 2) return;

  const preferredIndex = container.closest('collection-view')?.dataset.productMediaMode === 'secondary' ? 1 : 0;
  const previousIndex = Number(container.dataset.slideIndex ?? preferredIndex);
  const currentIndex = Number.isInteger(previousIndex) && previousIndex >= 0 && previousIndex < slides.length
    ? previousIndex
    : preferredIndex;
  let nextIndex;
  if (control.classList.contains('slider-arrow-left')) {
    nextIndex = currentIndex - 1;
  } else if (control.classList.contains('slider-arrow-right')) {
    nextIndex = currentIndex + 1;
  } else {
    const index = control.dataset.index;
    if (typeof index !== 'string' || index.trim() === '') return;
    nextIndex = Number(index);
    if (!Number.isInteger(nextIndex) || nextIndex < 0 || nextIndex >= slides.length) return;
  }

  event.preventDefault();
  event.stopPropagation();
  nextIndex = ((nextIndex % slides.length) + slides.length) % slides.length;
  container.dataset.slideIndex = String(nextIndex);
  wrapper.style.transform = `translateX(-${nextIndex * 100}%)`;
  container.querySelectorAll('.segment').forEach((segment, index) => {
    segment.classList.toggle('active', index === nextIndex);
  });
});
